import { ReactElement } from 'react';
import styles from '@utmb/features/my-dashboard/my-dashboard.module.scss';
import { Link } from '@utmb/design-system/link/link';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconsEnum } from '@utmb/types/icons';

interface ArrowLinkProps {
    url: string;
    label: string;
    className?: string;
    target?: '_self' | '_blank' | undefined;
    onClick?: () => void;
}

export const ArrowLink = (props: ArrowLinkProps): ReactElement => {
    const { label, url, className, target, onClick } = props;
    return (
        <Link
            href={url}
            onClick={(e) => {
                if (onClick) {
                    e.preventDefault();
                    onClick();
                }
            }}
            className={[styles.arrowlink, className].filter(Boolean).join(' ')}
            target={target}
        >
            {label}
            <Icon variant={IconsEnum.ARROW} />
        </Link>
    );
};
